document.addEventListener("variant:changed", function (event) {
  const variant = event.detail.variant;
  const bis = document.querySelector(".klaviyo-bis-trigger");

  if (bis) {
    if (variant.available) {
      bis.classList.add("hide");
    } else {
      bis.classList.remove("hide");
    }
  }
});

$(document).on("click", ".for-bundle-product-only", function () {
  var triggerId = $(this).attr("trigger-id");
  var mainProductKey = $(this).attr("data-id");

  var productKeys = [];

  // Gathering all product keys from elements with the class specified in 'trigger-id'
  $(triggerId).each(function () {
    var productKey = $(this).attr("data-id");
    if (productKey !== mainProductKey) {
      productKeys.push(productKey);
    }
  });

  // Add the main product key to the list of product keys to be removed
  if (mainProductKey) {
    productKeys.push(mainProductKey);
  }

  deleteProductsFromCart(productKeys)
    .then(function () {
      console.log("Products deleted successfully");
    })
    .catch(function (error) {
      console.error("Error deleting products:", error);
    });
});

function deleteProductsFromCart(productKeys) {
  return new Promise(function (resolve, reject) {
    var data = {
      updates: {},
    };

    productKeys.forEach(function (productKey) {
      data.updates[productKey] = 0; // Setting quantity to 0 to remove the product from the cart
    });

    $.ajax({
      type: "POST",
      url: "/cart/update.js",
      data: JSON.stringify(data),
      contentType: "application/json",
      dataType: "json",
      success: function () {
        resolve();
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:refresh", {
            bubbles: true,
          })
        );
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:update", {
            bubbles: true,
          })
        );
        $(".cart-icon-trigger").attr("aria-expanded", "true");
      },
      error: function (jqXHR, textStatus, errorThrown) {
        reject(errorThrown);
      },
    });
  });
}

$(document).on("variant:changed", function (event) {
  let variant = event.originalEvent.detail.variant;
  let variantId = variant.id;
  let variantElement = $("#variant-" + variantId);

  if (variantElement.length > 0) {
    let restockDate = variantElement.attr("data-metafields");

    if (restockDate) {
      $(".inventory--empty .inventory--empty").html(restockDate);
    }
  }
});

// additional item script start
$(document).on("variant:changed", function (event) {
  var variant = event.detail.variant; // Access the whole variant details
  var datameta = $("#get_additional-" + variant.id).attr("ajaxid");

  $("#additional-meta").val(datameta);

  if (!datameta) {
    // Check if datameta is empty
    $("#additional-meta").attr("disabled", true);
    $("#additional-meta2").attr("disabled", true);
  } else {
    $("#additional-meta").removeAttr("disabled"); // Remove disabled attribute
    $("#additional-meta2").removeAttr("disabled"); // Remove disabled attribute
  }
});

$(document).on("variant:changed", function (event) {
  var variant = event.detail.variant; // Access the whole variant details
  var datameta = $("#get_additional-" + variant.id).attr("datatitle");
  // var datameta2 = $("#get_additional-" + variant.id).attr("dataimage");

  $("#additional-meta").val(datameta);
  // $("#additional-meta2").val(datameta2);

  //update Option Values
  var options = $(".product-form__option-value");
  if (options[0]) {
    $(".product-form__option-value")[0].textContent =
      event.detail.variant.option1;
  }
  if (options[1]) {
    $(".product-form__option-value")[1].textContent =
      event.detail.variant.option2;
  }
  if (options[2]) {
    $(".product-form__option-value")[2].textContent =
      event.detail.variant.option3;
  }
});

function updateAllSelectedOptionValues() {
  // Loop through each combo box in the document
  document.querySelectorAll(".combo-box").forEach((comboBox) => {
    // Find the selected option inside the current combo box
    const selectedOption = comboBox.querySelector(
      '.combo-box__option-item[aria-selected="true"]'
    );

    if (selectedOption) {
      // Ensure the get-selected-value span exists before accessing textContent
      const selectedValueElement = selectedOption.querySelector(
        ".get-selected-value"
      );
      if (selectedValueElement) {
        const selectedValue = selectedValueElement.textContent.trim();

        // Find the closest .product-form__option-selector and its .product-form__option-value
        const optionSelector = comboBox.closest(
          ".product-form__option-selector"
        );
        const optionValueElement = optionSelector
          ? optionSelector.querySelector(".product-form__option-value")
          : null;

        // Update the .product-form__option-value text if it exists
        if (optionValueElement) {
          optionValueElement.textContent = selectedValue;
        }
      }
    }
  });
}
document.addEventListener("variant:changed", function (event) {
  // Run the function in the console
  updateAllSelectedOptionValues();

  // Update Forever Out of Stock flag
  var variant = event.detail.variant; // Access the whole variant details

  var NeverBackInStockIds = $(".product-form__buy-buttons").data(
    "never_back_in_stock_ids"
  );

  if (NeverBackInStockIds != "" && NeverBackInStockIds.includes(variant.id)) {
    // Id is neverbackinStock
    document
      .getElementsByClassName("product-form__buy-buttons")[0]
      .setAttribute("data-hide_out_of_stock_initial", "true");
  } else {
    document
      .getElementsByClassName("product-form__buy-buttons")[0]
      .setAttribute("data-hide_out_of_stock_initial", "false");
  }
});

$(".inner-slider-cl-sl").slick({
  infinite: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  dots: false,
  prevArrow: `
    <svg width="18" height="34" viewBox="0 0 18 34" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16.9911 33L1 16.952L17 1" stroke="#323232" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

`,
  nextArrow: `<svg width="18" height="34" viewBox="0 0 18 34" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.00889 1L17 17.048L1 33" stroke="#323232" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`,
});

// Featured image from metafield show/hide
  $(document).ready(function() {
    var lang = $('html').attr('lang');
    var english_media = $('.english_media');
    var german_media = $('.german_media');    
    
    if(english_media.length && german_media.length){
      if (lang === 'en') {
        english_media.show();
        german_media.hide();
      } else {
        english_media.hide();
        german_media.show();
      }
    }
    
  });